import React, { useEffect, useState } from "react";
// import { LoadingOverlay, Loader } from "react-overlay-loader";
import "react-responsive-modal/styles.css";
import "./saveforlater.css";
import { Modal } from "react-responsive-modal";
import { useCookies } from "react-cookie";


const SaveForLater = () => {
    const [loaded, setLoaded] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [cartData, setCartdata] = useState([]);
    const [removedItem, setremovedItem] = useState([]);
    const [removed, setremoved] = useState([]);
    const [cookies, setCookie] = useCookies("gemfind_sessionId");

    useEffect(() => {
        const nativeFetch = window.fetch;
        window.fetch = async function (...args) {
            let thisUrl = args[0].replace(/\?(.+)/ig, "");
            if (thisUrl.includes('/cart/change')) {
                let response = await nativeFetch.apply(window, args);
                if (response.status === 200) {
                    Removedcheck();
                    console.log('a')
                }
                return response;
            } else {
                return nativeFetch.apply(window, args);
            }
        };

        return () => {
            window.fetch = nativeFetch;
        };
    }, []);

    useEffect(()=>{
        if(loaded){
            document.querySelector(".gf--loader--body").style="display:block;";
        }else{
            document.querySelector(".gf--loader--body").style="display:none;";
        }
    },[loaded]);
    
    useEffect(() => {
        cartjs();
    }, [loaded]);

    async function cartjs() {
        try {
            var requestOptions = {
                method: 'GET',
                redirect: 'follow'
            };
            const res = await fetch("/cart.js", requestOptions);
            if (!res.ok) {
                throw new Error('Network response was not ok');
            }
            const set_count = await res.json();
            setCartdata(set_count.items);
            setremovedItem(set_count.items);
        } catch (error) {
            console.error(error);
        }
    }

    function Removedcheck() {
        var requestOptions = {
            method: 'GET',
            redirect: 'follow'
        };
        fetch("/cart.js", requestOptions)
            .then(response => response.text())
            .then(result => {
                setremovedItem(JSON.parse(result).items);
            })
            .catch(error => console.log('error', error));
    }

    useEffect(()=>{
        if(cartData.length > removedItem.length){
            setIsOpen(true);
            setCartdata(removedItem);
        }
        // console.log(cartData)
        
        const missingObject = cartData.find(obj1 => !removedItem.some(obj2 => obj2.id === obj1.id));
        setremoved(missingObject);
    },[removedItem])
    


    async function Saveforlaterfunc(e) {
        setLoaded(true);
        var handle = e.target.getAttribute('data-handle');
        var quantity = e.target.getAttribute('data-quantity');
        const requestOptions = {
            method: "POST",
            // mode: 'no-cors',
            body: JSON.stringify({
                shop_domain: window.Shopify.shop,
                session_id: cookies.gemfind_sessionId,
                handle: handle,
                product_id: '',
                comments: '',
                saveforlater:'true',
                quantity: quantity,
                wishlist_id: btoa('SFL'),
                customer_id:
                    window.meta.page.customerId != undefined
                        ? window.meta.page.customerId
                        : null
            })
        };
        const res = await fetch(
            `${process.env.REACT_APP_API_URL}` + "addToWishlist",
            requestOptions
        );
        setIsOpen(false);
        setLoaded(false);
    }
   

    const content1 = (
        <>
            <Modal
                open={isOpen}
                onClose={() => { setIsOpen(false); }}
                center
                classNames={{
                    overlay: "popup_Overlay",
                    modal: "popup-form-extra-small"
                }}
            >
                {/* <LoadingOverlay className="_loading_overlay_wrapper">
                    <Loader fullPage loading={loaded} />
                </LoadingOverlay> */}
                <div className="gf-sfl-modal">
                    <h2>Do you want to save this product for later?</h2>
                    <div className="gf-sfl-title"  data-id={removed ? removed.product_id : ''} data-var-id={removed ? removed.variant_id : ''} >
                        <p>{removed ? removed.title : ''}</p>
                    </div>
                    <div className="gf-save-for-later-btns">
                        <button onClick={()=>setIsOpen(false)}>No thanks!</button>
                        <button onClick={(e)=>Saveforlaterfunc(e)} data-handle= {removed ? removed.handle : ''} data-quantity={removed ? removed.quantity : ''} data-id={removed ? removed.product_id : ''}>Save for later</button>
                    </div>
                </div>
            </Modal>
        </>
    );

    return (
        <div>{content1}</div>
    );
}

export default SaveForLater;
